// extracted by mini-css-extract-plugin
export default {"container":"ClaimSummary_container__INO8+","header":"ClaimSummary_header__rGrUU","headerBox":"ClaimSummary_headerBox__1GURO","tabsContainer":"ClaimSummary_tabsContainer__KSOmn"};